@if (isMenu) {
  <button mat-menu-item>
    <div class="item-menu-center">
      <span class="material-symbols-outlined"> drafts </span>
      <span>{{ 'setRead' | translate }}</span>
    </div>
  </button>
} @else {
  <button mat-icon-button matTooltip="{{ 'setRead' | translate }}">
    <span class="material-symbols-outlined"> drafts </span>
  </button>
}
